import http from '../http-engine';

export default {
  getMetaData() {
    return http.get('/api/v1/metadata');
  },
};
